import { render } from "./PostArticleNav.vue?vue&type=template&id=144a5f50&scoped=true"
import script from "./PostArticleNav.vue?vue&type=script&lang=js"
export * from "./PostArticleNav.vue?vue&type=script&lang=js"

import "./PostArticleNav.vue?vue&type=style&index=0&id=144a5f50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144a5f50"]])

export default __exports__